import { type ReactElement } from 'react';

export const NotFound = ({ title, icon }: { title: string; icon: ReactElement }) => (
  <div className="flex min-h-screen items-center justify-center bg-neutral-950 text-white">
    <div className="flex flex-col items-center gap-5 rounded-lg bg-yellow-500/10 p-10">
      {icon}
      {title}
    </div>
  </div>
);
